
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25.59 25.59"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12.79","cy":"12.79","r":"12.29","fill":"#fff","stroke":"#e6e5e5","stroke-miterlimit":"10","data-name":"Ellipse 1242 Image"}}),_c('path',{attrs:{"d":"M11.7 14.97v-.26a3.58 3.58 0 011.58-2.87 2.23 2.23 0 00.93-1.79 1.23 1.23 0 00-1.36-1.34c-1 0-1.39.66-1.5 1.54h-2a3.24 3.24 0 013.55-3.08c2.53 0 3.3 1.68 3.3 2.92a3.49 3.49 0 01-1.5 2.83 2.4 2.4 0 00-1 1.89v.16zm0 3.44v-2.5h2v2.5z","fill":"#05123d","data-name":"?"}})])
          )
        }
      }
    